import { motion } from "framer-motion";
import { useContent } from "@/content/ContentContext";
import { useLang } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export default function Stats() {
  const content = useContent();
  const { t } = useLang();
  const stats = content.stats;
  return (
    <section
      id="why"
      data-testid="stats-section"
      className="border-t border-line"
    >
      <div className="mx-auto max-w-[1440px] px-6 py-20 lg:px-12 lg:py-28">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
          className="text-xs uppercase tracking-[0.3em] text-harvest"
        >
          {t("statsOverline")}
        </motion.p>

        <div className="mt-12 grid grid-cols-1 border border-line sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease }}
              data-testid={`stat-${i}`}
              className="border-line p-10 [&:not(:last-child)]:border-b sm:[&:nth-child(odd)]:border-r lg:[&:not(:last-child)]:border-r lg:[&:not(:last-child)]:border-b-0 sm:[&:nth-child(-n+2)]:border-b lg:[&:nth-child(-n+2)]:border-b-0"
            >
              <p className="font-display text-5xl font-medium tracking-tight text-harvest lg:text-6xl">
                {s.value}
              </p>
              <p className="mt-4 text-xs uppercase tracking-[0.2em] text-sage">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
